"use client"

import {usePathname} from "next/navigation";
import {matchPath} from "react-router";
import {useIsMobile} from "@/hooks/use-mobile";
import {
  bugsPath,
  chatsPath,
  changelogPath,
  companyOnboardingPath,
  companyPath,
  dashboardsPath,
  decisionsPath,
  documentPath,
  goalPath,
  goalsPath,
  historyPath,
  homeReportPath,
  ideasPath,
  insightsPath,
  integrationsPath,
  knowledgeCompanyPath,
  knowledgeFeatureCataloguePath,
  knowledgeReposPath,
  memoriesPath,
  projectPath,
  projectsPath,
  projectsKanbanPath,
  projectsListPath,
  projectsRoadmapPath,
  radarPath,
  roadmapPath,
  quickWinsPath,
  signalsPath,
  tabLayoutCustomTabPath,
  tabLayoutTabPath
} from "@/app/paths";

export interface ViewProps {
  standardTopNav: boolean;
  standardScroll: boolean;
  standardPadding: boolean;
}

export function useViewProps(): ViewProps {
  const pathname = usePathname();
  const isMobile = useIsMobile();
  const docMatch = matchPath({path: documentPath(":companyId", ":documentId")}, pathname)
  const projectViewMatch = matchPath({path: projectsRoadmapPath(":companyId")}, pathname) ||
    matchPath({path: projectsListPath(":companyId")}, pathname) ||
    matchPath({path: projectsKanbanPath(":companyId")}, pathname)
  const projectsMatch = matchPath({path: projectsPath(":companyId")}, pathname)
  const projectMatch = !projectViewMatch && matchPath({path: projectPath(":companyId", ":projectId")}, pathname)
  const tabMatch = matchPath({path: tabLayoutTabPath(":companyId", ":projectId", ":tab")}, pathname)
  const customTabMatch = matchPath({path: tabLayoutCustomTabPath(":companyId", ":projectId", ":documentId")}, pathname)
  const homeMatch = matchPath({path: companyPath(":companyId")}, pathname)
  const homeNewMatch = matchPath({path: `${companyPath(":companyId")}/home-new`}, pathname)
  const knowledgeWorkspaceMatch = matchPath({path: knowledgeCompanyPath(":companyId")}, pathname)
  const featureCatalogueMatch = matchPath({path: knowledgeFeatureCataloguePath(":companyId")}, pathname)
  const decisionsMatch = matchPath({path: `${decisionsPath(":companyId")}/*`}, pathname) ||
    matchPath({path: decisionsPath(":companyId")}, pathname) ||
    matchPath({path: `${memoriesPath(":companyId")}/*`}, pathname) ||
    matchPath({path: memoriesPath(":companyId")}, pathname)
  const dashboardsMatch = matchPath({path: `${dashboardsPath(":companyId")}/*`}, pathname) ||
    matchPath({path: dashboardsPath(":companyId")}, pathname)
  const goalsMatch = matchPath({path: goalsPath(":companyId")}, pathname)
  const goalMatch = matchPath({path: goalPath(":companyId", ":goalId")}, pathname)
  const repoResearchMatch = matchPath({path: `${knowledgeReposPath(":companyId")}/research/:repoId`}, pathname) ||
    matchPath({path: `${knowledgeReposPath(":companyId")}/research/:repoId/area/:dirKey`}, pathname)
  const ideasMatch = matchPath({path: ideasPath(":companyId")}, pathname)
  const quickWinsMatch = matchPath({path: quickWinsPath(":companyId")}, pathname)
  const bugsMatch = matchPath({path: bugsPath(":companyId")}, pathname)
  const roadmapMatch = matchPath({path: roadmapPath(":companyId")}, pathname)
  const updatesMatch = matchPath({path: changelogPath(":companyId")}, pathname)
  const signalsMatch = matchPath({path: signalsPath(":companyId")}, pathname)
  const insightsMatch = matchPath({path: `${insightsPath(":companyId")}/*`}, pathname) ||
    matchPath({path: insightsPath(":companyId")}, pathname)
  const radarMatch = matchPath({path: `${radarPath(":companyId")}/*`}, pathname) ||
    matchPath({path: radarPath(":companyId")}, pathname)
  const historyMatch = matchPath({path: historyPath(":companyId")}, pathname)
  const reportMatch = matchPath({path: homeReportPath(":companyId", ":reportId")}, pathname)
  const integrationsV2Match = matchPath({path: integrationsPath(":companyId")}, pathname)
  const onboardMatch = matchPath({path: companyOnboardingPath(":companyId")}, pathname)
  const chatsMatch = matchPath({path: `${chatsPath(":companyId")}/*`}, pathname) ||
    matchPath({path: chatsPath(":companyId")}, pathname)
  return {
    standardTopNav: !docMatch && !projectMatch,
    standardScroll: !docMatch && !projectMatch
      && (!featureCatalogueMatch || isMobile)
      && (!repoResearchMatch || isMobile),
    standardPadding: !docMatch && !projectMatch && !projectViewMatch && !projectsMatch && !roadmapMatch && !homeMatch && !homeNewMatch && !tabMatch && !customTabMatch && !featureCatalogueMatch && !repoResearchMatch && !updatesMatch && !signalsMatch && !insightsMatch && !radarMatch && !historyMatch && !reportMatch && !knowledgeWorkspaceMatch && !ideasMatch && !quickWinsMatch && !bugsMatch && !integrationsV2Match && !onboardMatch && !chatsMatch && !decisionsMatch && !dashboardsMatch && !goalsMatch && !goalMatch,
  }
}
